export default "__VITE_ASSET__2fe8c80d__"